module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_2@2x.b50908c2.png";